<template>
	<div class="container">
		<div class="row">
			<div class="col-12 pb-3 pb-lg-5">
				<h2>
					Skontaktuj się
				</h2>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-4 contact-data pb-5 pb-lg-0">
				<div class="mb-3">
					<p class="mb-0">
						Stacjonarny
					</p>
					<a href="tel:228121949" @click="phoneTracking('228-121-949')">228-121-949</a>
				</div>
				<div class="mb-3">
					<p class="mb-0">
						Komórka
					</p>
					<a href="tel:530330300" @click="phoneTracking('530-330-300')">530-330-300</a>
				</div>
				<div>
					<p class="mb-0">
						E-mail
					</p>
					<span v-html="fillEmail()" @click="emailTracking"></span>							
				</div>
			</div>
			<div class="col-12 col-lg-8">
				<Form />
			</div>
		</div>
	</div>
</template>

<script>
	import Form from '@/components/Form.vue';
	export default{
		components: {
			Form
		},
		methods: {
			fillEmail (){
				let part1 = "biuro",
					part2 = Math.pow(2,6),
					part3 = String.fromCharCode(part2),
					part4 = "ango.waw.pl",
					part5 = part1 + String.fromCharCode(part2) + part4;

				return '<a href=' + 'mai' + 'lto' + ':' + part5 + ' >' + part1 + part3 + part4 + '</a>';
			},
			phoneTracking(number) {
				this.$gtag.event('Wybranie numeru', {
					'event_category': 'Zadzwoń do nas',
					'event_label': number,
					'non_interaction': false
				})
			},
			emailTracking() {
				this.$gtag.event('Kliknięcie w email', {
					'event_category': 'E-mail',
					'event_label': 'biuro@ango.waw.pl',
					'non_interaction': false
				})
			}
		}
	}
</script>